import { PostMessage, PostMessageReply } from '../Shared/PostMessage';

export const MessageTypes_PresenceColorProvider_GetColor = 'PresenceColorProvider_GetColor';

export interface Message_PresenceColorProvider_GetColorsRequest
  extends PostMessage<typeof MessageTypes_PresenceColorProvider_GetColor> {
  /** The user ID */
  payload: string;
}

export interface Message_PresenceColorProvider_GetColorsResponse extends PostMessageReply {
  /** The resulting color */
  payload: string;
}
